import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { OnboardingService } from '../../services/onboarding-wizard/onboarding.service'
import {
  save_entities,
  save_entities_success,
  save_sop_settings,
  save_sop_settings_success,
  save_company_success_action,
  save_company_action,
  save_others,
  save_others_success,
  loadScreenConfigsByCompanyGroup,
  loadScreenConfigsByCompanyGroupSuccess,
  saveScreenConfigSuccess,
  saveScreenConfig,
  onboardingGoToNextStep, assign_employee_admins, assign_employee_admins_success
} from '../action/onboarding.action'

import { catchError, mergeMap, map, of } from 'rxjs'
import {
  route_to_action,
  show_display_id_after_created_action,
  show_error_action,
  show_success_msg_action
} from '../action/common/common.action'

@Injectable()
export class OnboardingEffects {
  constructor(private actions$: Actions, private onboardingService: OnboardingService) {}

  save_company_effect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_company_action),
      mergeMap(({ company, routeTo }) =>
        this.onboardingService.saveCompanyApi(company).pipe(
          mergeMap(res => [
            save_company_success_action({ company: res, routeTo }),
            show_display_id_after_created_action({
              moduleName: 'Company',
              displayId: res.code
            })
          ]),
          catchError(error => of(show_error_action({ data: null, error })))
        )
      )
    )
  )

  save_entities_effect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_entities),
      mergeMap(({ entities }) =>
        this.onboardingService.saveEntitiesApi(entities).pipe(
          mergeMap(res => {
            const mapped = res.map(e => ({
              ...e,
              company: e.companyGroup ?? null
            }))

            const displayIds = mapped
              .map(e => e.displayId)
              .filter(id => !!id)
              .join(', ')

            return [
              save_entities_success({ entities: mapped }),
              show_display_id_after_created_action({
                moduleName: 'Company Entity',
                displayId: displayIds
              })
            ]
          }),
          catchError(error => of(show_error_action({ data: null, error })))
        )
      )
    )
  )

  // -------- STEP 3: SOP SETTINGS --------
  save_sop_settings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_sop_settings),
      mergeMap(({ payload }) =>
        this.onboardingService.saveSopSettingsApi(payload).pipe(
          mergeMap(() => [
            save_sop_settings_success(),
            show_success_msg_action({ msg: 'SOP Settings Applied Successfully.' })
          ]),
          catchError(error =>
            of(show_error_action({ data: null, error }))
          )
        )
      )
    )
  )
  // -------- STEP 4: EMPLOYEES --------
  assignEmployeeAdmins$ = createEffect(() =>
    this.actions$.pipe(
      ofType(assign_employee_admins),
      mergeMap(({ payload, moveNext }) =>
        this.onboardingService.assignEmployeeAdmins(payload).pipe(
          mergeMap(() =>
            of(
              assign_employee_admins_success({ moveNext }),
              show_success_msg_action({
                msg: 'Employee admins assigned successfully.'
              }),
              ...(moveNext
                ? [onboardingGoToNextStep({ props: { type: 'EMPLOYEE_ADMINS' } })]
                : [])
            )
          ),
          catchError(error =>
            of(show_error_action({ data: null, error }))
          )
        )
      )
    )
  )


  // -------- STEP 5: SCREEN CONFIG --------
  // @ts-ignore
  loadAllByCompanyGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadScreenConfigsByCompanyGroup),
      mergeMap(({ companyGroupId }) =>
        this.onboardingService.getConfigsByCompanyGroup(companyGroupId).pipe(
          map(configs =>
            loadScreenConfigsByCompanyGroupSuccess({
              configs
            })
          ),
          catchError(error => of(show_error_action({ data: null, error })))
        )
      )
    )
  )

  save$ = createEffect(() =>
    this.actions$.pipe(
      ofType(saveScreenConfig),
      mergeMap(({ config }) =>
        this.onboardingService.save(config).pipe(
          mergeMap(saved => [saveScreenConfigSuccess({ config: saved }), onboardingGoToNextStep({ props: saved })]),
          catchError(error => of(show_error_action({ data: null, error })))
        )
      )
    )
  )

  // -------- STEP 6: OTHERS --------
  save_others$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_others),
      mergeMap(({ companyGroupId, others, completeOnboarding }) =>
        this.onboardingService.saveOthers(companyGroupId, others, completeOnboarding).pipe(
          mergeMap(res => [
            save_others_success({ companyGroup: res }),
            route_to_action({ routeTo: '/settings' }),
            show_success_msg_action({ msg: 'Comany Onboarded Successfully.' })
          ]),
          catchError(error => of(show_error_action({ data: null, error })))
        )
      )
    )
  )
}
